<div fxLayout="row" class="featuresSectionTitle">
  Τι μπορείτε να κάνετε με την υπηρεσία e-Apply
</div>

<div fxLayout="row wrap">

  <div fxLayout="column" fxFlex="20" fxLayoutAlign="start center center" fxShow.gt-sm fxHide.lt-md>
    <img src="../../../../assets/images/intro2.PNG" alt="intro" style="height:200px; width:200px;">
  </div>

  <div fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="80" fxFlex.lt-md="100">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxFlex fxLayoutAlign="center center">
        <mat-card *ngFor="let item of features" class="card mat-elevation-z0">
          <mat-card-content class="cardContent">
            <div fxLayout="column">
              <span class="strong-title">{{item.title}}</span>
              <span style="letter-spacing: 0.2px;">{{item.description}}</span>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div fxLayoutAlign="center center">
              <div class="cardFooter">
                <span>Θέλω να μάθω περισσότερα</span>
              </div>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>
</div>
